import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  DocumentData,
} from 'firebase/firestore';
import { FirestoreDocument } from '../../@types/domain';

export function getDefaultConverter<
  T extends FirestoreDocument
>(): FirestoreDataConverter<T> {
  return {
    fromFirestore(
      snapshot: QueryDocumentSnapshot<T>,
      options: SnapshotOptions
    ): T {
      const data = snapshot.data(options);
      return {
        ...data,
        id: snapshot.id,
        ref: snapshot.ref,
      };
    },

    toFirestore(modelObject): DocumentData {
      const { id, ref, ...firestoreDocument } = modelObject;
      return firestoreDocument as Omit<T, 'id' | 'ref'>;
    },
  };
}
